import {
  IoSpeedometerOutline,
  IoGridOutline,
  IoReaderOutline,
  IoImagesOutline,
  IoSettingsOutline,
  IoGiftOutline,
  IoHomeOutline,
} from "react-icons/io5";

const config = (userRole) => {
  //Owner
  const ownerMenus = [
    {
      title: "home",
      path: "/app/home",
      icon: "carbon:home",
      iconType: "custom",
      type: "item",
      role: ["owner"],
    },
    {
      title: "table",
      path: "/app/tables",
      icon: <IoGridOutline />,
      type: "item",
      role: ["owner"],
    },
    {
      title: "menu",
      path: "/app/menu",
      icon: "ic:baseline-menu-book",
      iconType: "custom",
      type: "item",
      role: ["owner"],
    },
    {
      title: "orders",
      path: "/app/orders",
      icon: "mdi:cart-outline",
      iconType: "custom",
      type: "item",
      role: ["owner"],
    },
    {
      title: "History",
      path: "/app/order-history",
      icon: "mdi:clock-outline",
      iconType: "custom",
      type: "item",
      role: ["owner"],
    },
    {
      title: "customers",
      path: "/app/customers",
      icon: "ph:users-duotone",
      iconType: "custom",
      type: "item",
      role: ["owner"],
    },
    {
      title: "reports",
      path: "/app/reports",
      icon: "mdi:report-box-outline",
      iconType: "custom",
      type: "item",
      role: ["owner"],
    },
    {
      title: "users",
      path: "/app/users",
      icon: "mage:users",
      iconType: "custom",
      type: "item",
      role: ["owner"],
    },
    {
      title: "configurations",
      path: "/app/config",
      icon: "mdi:tune",
      iconType: "custom",
      type: "item",
      role: ["owner"],
    },
    {
      title: "settings",
      path: "/app/settings",
      icon: <IoSettingsOutline />,
      type: "item",
      role: ["owner"],
    },
  ];

  switch (userRole) {
    case "owner":
      return ownerMenus;
    case "store_counter_owner":
      return ownerMenus;
    case "store_counter_user":
      return ownerMenus;
    default:
      break;
  }
};

export default config;
